
<script>
    import linq from 'linq'

    export default {
        name: 'detail',

        data () {
            return {
                sizes: [],
                loading: false,
                bindValue: null,
                images: []
            }
        },

        props: {
            data: {
            },
        },

        created () {
            this.bindValue = eval(this.data)
            this.images = this.bindValue.images
        },

        async mounted () {
            //const colorId = linq.from(this.bindValue.product.mains).first().id
            //this.sizeChange(colorId, this.bindValue.product.id)
        },

        methods: {
            async sizeChange (id, product_id) {
                this.bindValue.product.subs = []
                this.bindValue.product.images = [{path: '/img/noimage.png'}]

                axios.post('/api/test-image', {
                    id: id, product_id: product_id
                }).then(x => {
                    this.bindValue.product.images = x.data
                })

                this.loading = true
                const { data } = await axios.post('/api/test-size', {
                    color_id: id, product_id: product_id
                })

                linq.from(data)
                    .select(x => this.bindValue.product.subs.push(x.size))
                    .toArray()

                this.loading = false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Detail.vue